/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CmsPage(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CmsPage',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 17 * scale,
      viewBox: '0 0 14 17',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M1 1v15h12V7L7 1zm6 1.414L11.586 7H7zM12 8v7H2V2h4v6z"}),createElement('path', {"opacity":".2","fill":"currentColor","d":"M7 2.414V7h4.586zM12 8H6V2H2v13h10z"}))
}
